export default "__VITE_ASSET__XVSmKJMe__"